'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var raf = require('raf');

var Notification = function (_React$Component) {
  _inherits(Notification, _React$Component);

  function Notification() {
    var _temp, _this, _ret;

    _classCallCheck(this, Notification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      persist: _this.props.persist,
      timeoutId: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Notification.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    // Wait two frames to ensure that the notification has rendered for the
    // animation to occur. Stupid browsers...
    this._raf = raf(function () {
      _this2._raf = raf(function () {
        _this2._raf = null;
        _this2.startTimeout();
      });
    });
  };

  Notification.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stopTimeout();
  };

  Notification.prototype.startTimeout = function startTimeout() {
    var _this3 = this;

    if (this.state.persist) {
      return;
    }
    this.stopTimeout();
    var timeoutId = setTimeout(function () {
      return _this3.props.onClose();
    }, this.props.delay);
    this.setState({ timeoutId: timeoutId });
  };

  Notification.prototype.stopTimeout = function stopTimeout() {
    if (this._raf) {
      raf.cancel(this._raf);
      this._raf = null;
    }
    if (this.state.timeoutId) {
      clearTimeout(this.state.timeoutId);
      this.setState({ timeoutId: null });
    }
  };

  Notification.prototype.handleMouseEnter = function handleMouseEnter() {
    this.stopTimeout();
  };

  Notification.prototype.handleMouseLeave = function handleMouseLeave() {
    this.startTimeout();
  };

  Notification.prototype.handleClickClose = function handleClickClose() {
    this.props.onClose();
  };

  Notification.prototype.handleClick = function handleClick() {
    this.stopTimeout();
    this.setState({
      persist: true
    });
  };

  Notification.prototype.render = function render() {
    var className = 'cf-notifications__item';
    var progress = void 0;

    className += ' cf-notifications__item--' + this.props.type;

    if (this.state.persist) {
      className += ' cf-notifications__item--persist';
    } else {
      var progressClassName = 'cf-notifications__item_progress';
      var progressStyles = {};

      if (this.state.timeoutId) {
        progressClassName += ' cf-notifications__item_progress--active';
        progressStyles.transitionDuration = this.props.delay + 'ms';
      }

      progress = React.createElement('span', { className: progressClassName, style: progressStyles });
    }

    var close = void 0;

    if (this.props.closable) {
      close = React.createElement('span', {
        className: 'cf-notifications__item_close',
        onClick: this.handleClickClose.bind(this) });
    }

    return React.createElement(
      'div',
      {
        role: 'alert',
        className: className,
        onClick: this.handleClick.bind(this),
        onMouseEnter: this.handleMouseEnter.bind(this),
        onMouseLeave: this.handleMouseLeave.bind(this) },
      progress,
      close,
      React.createElement(
        'span',
        { className: 'cf-notifications__item_message' },
        this.props.message
      )
    );
  };

  return Notification;
}(React.Component);

Notification.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'info', 'warning']),
  message: PropTypes.string.isRequired,

  closable: PropTypes.bool,
  delay: PropTypes.number,
  persist: PropTypes.bool,

  onClose: PropTypes.func.isRequired
};
Notification.defaultProps = {
  closable: true,
  delay: 4000,
  persist: false
};


module.exports = Notification;